import { useMatchMedia } from '@betterment/js-runtime';
import { Box, Text } from '@betterment/samba-react';

type Props = { title: string; value: string; subtitle?: string; legendColor: string };

export const SpendingPowerHighlight: React.FC<Props> = ({ title, value, subtitle, legendColor }) => {
  const isLargeScreen = useMatchMedia('atLeastMedium');

  if (isLargeScreen) {
    return (
      <Box css={{ display: 'flex', gap: 'space.100' }}>
        <Box
          css={{
            width: 'size.100',
            height: 'size.100',
            backgroundColor: legendColor,
            borderRadius: 'round',
            mt: '6px',
          }}
        />
        <Box css={{ display: 'flex', flexDirection: 'column' }}>
          <Text variant="text50">{title}</Text>
          <Text variant="text300">{value}/month</Text>
          {subtitle && (
            <Text variant="text50" color="text.weak">
              {subtitle}
            </Text>
          )}
        </Box>
      </Box>
    );
  }

  return (
    <Box css={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 'space.100' }}>
      <Box css={{ display: 'flex', alignItems: 'center', gap: 'space.150' }}>
        {legendColor && (
          <Box
            css={{
              width: 'size.100',
              height: 'size.100',
              backgroundColor: legendColor,
              borderRadius: 'round',
            }}
          />
        )}
        <Box css={{ display: 'flex', flexDirection: 'column' }}>
          <Text variant="text100">{title}</Text>
          {subtitle && (
            <Text variant="text50" color="text.weak">
              {subtitle}
            </Text>
          )}
        </Box>
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <Text>{value}</Text>
        <Text variant="text50" color="text.weak">
          Per month
        </Text>
      </Box>
    </Box>
  );
};
